import { Form } from 'antd'
import { useCallback, useContext } from 'react'
import { useTranslation } from 'react-i18next'

import FormWrap from '../../components/forms/FormWrap'
import FormBlock from '../../components/forms/FormBlock'

import { AppContext } from '../../context/AppContext'
import { EditCustomer } from '../../network/Customers'
import {
    PersonalInformation,
    Contacts,
    Fapiao,
    WeChatGroups,
    Address,
    Pets,
    CustomerTags,
    cleanBeforeSending,
} from '../../constants/forms/Customers'
import { promptLinkGiftCardsToCustomer } from '../../utils/customerGiftCardLink'

const CustomersInformations = ({ customer }) => {
    const [form] = Form.useForm()
    const { token } = useContext(AppContext)
    const { t } = useTranslation()

    const handleBeforeOnSuccess = useCallback(
        async (savedCustomer) => {
            await promptLinkGiftCardsToCustomer({
                customer: savedCustomer,
                token: token.token,
                t,
            })
        },
        [token.token, t]
    )

    return (
        <FormWrap
            form={form}
            title="create_recipe"
            request={EditCustomer}
            onSuccess="/customers"
            id={customer.id}
            data={customer}
            cleanBeforeSending={cleanBeforeSending}
            invalidate={['CustomerDetails', 'getCustomers', 'getGiftCards', 'getCustomerGiftCards']}
            beforeOnSuccess={handleBeforeOnSuccess}
        >
            <div className="SectionHorizontalWrap">
                <div className="SectionVerticalWrap" style={{ flex: 2 }}>
                    <FormBlock form={form} formTemplate={PersonalInformation} />
                    <FormBlock form={form} formTemplate={Address} />
                    <FormBlock form={form} formTemplate={Contacts} />
                    <FormBlock form={form} formTemplate={Fapiao} />
                </div>

                <div className="SectionVerticalWrap" style={{ flex: 1 }}>
                    <FormBlock form={form} formTemplate={WeChatGroups} />
                    <FormBlock form={form} formTemplate={Pets} />
                    <FormBlock form={form} formTemplate={CustomerTags} />
                </div>
            </div>
        </FormWrap>
    )
}
export default CustomersInformations
